import { UpdateEntrepreneurFormValues } from "src/core/forms/stakeholder/updateEntrepreneur.schema";
import {
  DataType,
  InputValueInput,
  UpdateStakeholderMutationVariables,
} from "src/core/gql/graphql";

export const buildUpdateEIVariables = (
  customerId: string,
  data: UpdateEntrepreneurFormValues
): UpdateStakeholderMutationVariables => {
  const fieldDescriptors: {
    fieldCode: keyof typeof data;
    dataType: DataType;
    transform?: (value: UpdateEntrepreneurFormValues[keyof UpdateEntrepreneurFormValues]) => string;
  }[] = [
    { fieldCode: "lastName", dataType: DataType.String },
    { fieldCode: "firstName", dataType: DataType.String },
    { fieldCode: "title", dataType: DataType.String },
    { fieldCode: "birthName", dataType: DataType.String },
    { fieldCode: "citizenshipCountryCode", dataType: DataType.Code },
    {
      fieldCode: "birthDate",
      dataType: DataType.Timestamp,
      // hack pour que la date de naissance soit au format UTC
      transform: (val) => (typeof val === "string" ? val.replace(/\+\d{2}:\d{2}/, "Z") : ""),
    },
    { fieldCode: "residenceCountryCode", dataType: DataType.Code },
    { fieldCode: "birthCountryCode", dataType: DataType.Code },
    { fieldCode: "birthPlace", dataType: DataType.String },
    { fieldCode: "registration", dataType: DataType.String },
    { fieldCode: "activityCode", dataType: DataType.Code },
    { fieldCode: "personLegalFormCode", dataType: DataType.Code },
    { fieldCode: "customString1", dataType: DataType.String }, // code postal
    { fieldCode: "customString2", dataType: DataType.String }, // adresse
    { fieldCode: "customCountryCode1", dataType: DataType.Code }, // pays
  ];

  const inputValues_0: InputValueInput[] = fieldDescriptors.map(
    ({ fieldCode, dataType, transform }) => {
      const rawValue = data[fieldCode];
      if ((typeof rawValue !== "string" && typeof rawValue !== "number") || rawValue === "") {
        return { fieldCode, dataType };
      }

      const value = transform ? transform(rawValue) : rawValue;
      return { fieldCode, dataType, value };
    }
  );

  const base: UpdateStakeholderMutationVariables = {
    id_0: customerId,
    inputValues_0,

    // Ces champs doivent toujours exister pour le typage, même s'ils ne seront jamais utilisés
    inputRole_1: { typeCode: "ignored_role" },
    corporationId_1: customerId,
    entityId_1: customerId,

    inputRole_2: {
      typeCode: "ignored_role",
      directBeneficiaryOwnerInput: {
        directBOReasonCode: "default",
        share: null,
        votingRights: null,
      },
    },

    corporationId_2: customerId,
    entityId_2: customerId,
  };

  return base;
};
